import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { ProvidersService } from '../../services/providers.service';

import * as decode from 'jwt-decode';

@Component({
  selector: 'app-retentions-detail',
  templateUrl: './retentions-detail.component.html',
  styleUrls: ['./retentions-detail.component.scss']
})
export class RetentionsDetailComponent implements OnInit {
  userId: any;
  userToken: any;
  textButton: any;
  loadBtn = false;
  type: any;
  info: any = {};
  editId: any;
  retentions: any;
  txtHeader: any;
  dataRet: any;
  listCharges = [];
  idProveedor: any;

  constructor(private toastr: ToastrService, private gralService: GeneralService, private provService: ProvidersService, public dialog: MatDialog, public dialogRef: MatDialogRef<RetentionsDetailComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    this.type = this.data.type;
    this.retentions = this.data.retentions;
    this.editId = this.data.id;
    this.idProveedor = this.data.idProveedor;
    if(this.data.ret){
      this.dataRet = this.data.ret.idRetencion;
    }

    if(this.type == 'addRetention'){
      this.txtHeader = 'ADDRETENTION';
    }else{
      this.txtHeader = 'REASIGNRETENTION';
    }
  }

  ngOnInit() {
  }

  onCloseConfirm() {
    this.dialogRef.close({ data: true });
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  assign(){
    const params = {IdRetencion: this.dataRet, IdProveedor: this.idProveedor};
    this.loadBtn = true;
    this.provService.assignRetentions(params, this.userToken).then((data) => {
      this.loadBtn = false;
      console.log(data);
      if(data['asignacionCorrecta']){
        const assign = this.retentions.find(x => x.idRetencion === this.dataRet);
        this.dialogRef.close({ assign: assign.retencionDesc, assignId: assign.idRetencion});
      }else{
        this.toastr.info(data['lsMensajes'][0].value, 'Retenciones');
      }
    }, (err) => {
      console.log(err);
      this.toastr.error(err['error'][0].Response.Mensaje, 'Retenciones');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

}
